<nb-card>
  <nb-card-body class="p-0" style="min-height: 40px; overflow: hidden">
    <form tabindex="0" [formGroup]="awsAccountForm" class="row mt-2">
      <div class="col-md-12 mt-3">
        <app-reactive-form-field
          label="Name"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="4"
          fieldId="name"
          fieldName="name"
          inputSize="7"
          placeholder="Enter unique name for the account"
          [customFormControl]="name"
          missingMsg="Name is required!"
          invalidPatternMsg="AWS account name should be a lowercase alphanumeric string and can only have hyphens"
        ></app-reactive-form-field>
      </div>
      <div class="col-md-12 mt-3">
        <app-reactive-form-field
          label="External ID"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="4"
          fieldId="externalId"
          fieldName="externalId"
          inputSize="7"
          placeholder="Enter External ID"
          [customFormControl]="externalId"
          missingMsg="External id is required!"
          invalidPatternMsg="External id is invalid!"
          [tooltipText]="'External ID to be selected along with IAM role'"
        >
        </app-reactive-form-field>
      </div>

      <div class="col-md-12 mt-3">
        <app-reactive-form-field
          label="IAM Role"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="4"
          fieldId="role"
          fieldName="role"
          inputSize="7"
          placeholder="Enter IAM Role"
          [customFormControl]="role"
          missingMsg="IAM role is required!"
          invalidPatternMsg="IAM role is invalid!"
          [tooltipText]="
            'IAM role created as per documentation for provisioning environment in your account.'
          "
        >
          <ng-container
            *ngIf="mode === 'create' && externalId?.value?.length > 0"
            fieldNote
          >
            To Obtain the IAM Role, run the
            <a href="{{ getUrl() }}" target="_blank">
              <b>CF template</b>
            </a>
          </ng-container>
        </app-reactive-form-field>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="p-0 pt-3">
    <app-rbac-button
      [label]="mode === 'create' ? 'Create' : 'Update'"
      class="mr-3"
      status="primary"
      [action]="ACCOUNTS_WRITE"
      [loading]="saveAccountInProgress"
      [disabled]="awsAccountForm.invalid || saveAccountInProgress"
      (onClick)="createEditAwsAccount()"
    ></app-rbac-button>
    <app-rbac-button
      [label]="'Verify Account'"
      class="mr-3"
      status="primary"
      [action]=""
      [loading]="verifyInProgress"
      [disabled]="awsAccountForm.invalid || verifyInProgress"
      (onClick)="verifyAccount()"
      appearance="outline"
    ></app-rbac-button>
    <button
      nbButton
      size="small"
      class="mr-3"
      (click)="onClickHandleCancel(passedRef)"
    >
      Cancel
    </button>
  </nb-card-footer>
</nb-card>
